@switch (type) {
  @case ('no-title-dashboard') {
    <div class="card card-dashboard" [class]="cardClass">
      <div class="card-body-dashboard d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-3 d-inline-block">
          <div class="d-inline-block rounded-circle" [class]="'circle-icon-' + iconColor">
            <i [class]="icon"></i>
          </div>
          <p class="p-0 m-0 text-dark fs-22">{{ title }}</p>
        </div>
        <p class="card-body-value p-0 m-0 text-dark">
          @if (isLoading) {
            <p-skeleton width="7rem" height="45px"></p-skeleton>
          } @else {
            @if (!value) {
              -
            } @else {
              {{ value }}
            }
          }
        </p>
      </div>
    </div>
  }
  @case ('no-title') {
    <div class="card" [class]="cardClass">
      <div class="card-body d-flex justify-content-between align-items-center gx-2">
        <div class="d-flex align-items-center gap-1 d-inline-block">
          <div class="d-inline-block rounded-circle" [class]="'circle-icon-' + iconColor">
            <i [class]="icon"></i>
          </div>
          <p class="p-0 m-0 text-muted">{{ title }}</p>
        </div>
        <p class="p-0 m-0 text-dark fs-22">
          @if (isLoading) {
            <p-skeleton width="4rem" height="40px"></p-skeleton>
          } @else {
            @if (!value && value != 0) {
              -
            } @else {
              {{ value }}<span>{{ valueType | valueSuffix }}</span>
            }
          }
        </p>
      </div>
    </div>
  }
  @case ('invoice') {
    <div class="card" [class]="cardClass">
      <div class="card-header gap-2">
        <div class="d-inline-block rounded-circle" [class]="iconColor">
          <i [class]="icon"></i>
        </div>
        <p class="p-0 m-0 text-dark fs-20">{{ title }}</p>
      </div>
      <div class="card-body-dashboard">
        <div class="row gap-y-2 text-dark">
          <p class="p-0 m-0 mb-1 text-dark fs-5 card-body-value">
            @if (isLoading) {
              <p-skeleton width="7rem" height="45px"></p-skeleton>
            } @else {
              @if (!value && value != 0) {
                -
              } @else {
                {{ value }}<span>{{ valueType | valueSuffix }}</span>
              }
            }
          </p>
          <p class="p-0 m-0 d-flex align-items-center gx-2 fs-15">
            @if (profit) {
              @if (isLoading) {
                <p-skeleton height="30px" width="50px"></p-skeleton>
              } @else {
                @if (value || value === 0) {
                  <small class="p-1 rounded fw-bolder" [style]="getProfitStyle(profitType)">
                    {{ profit }}
                  </small>
                } @else {
                  -
                }
              }
            }
            <span class="p-1 card-body-subtext m-0">{{ subtext }}</span>
            <span class="card-body-subtext">{{ period || '' }}</span>
          </p>
        </div>
      </div>
    </div>
  }
  @case ('double-value') {
    <div class="card" [class]="cardClass">
      <div class="card-header gap-2 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-2">
          <div class="d-inline-flex align-items-center justify-content-center rounded-circle"
               [class]="'circle-icon-' + iconColor">
            <i [class]="icon"></i>
          </div>
          <div>
            <p class="p-0 m-0 text-dark fs-20">{{ title }}</p>
            <p class="p-0 m-0 text-dark fs-14 text-muted">{{ subTitle }}</p>
          </div>
        </div>
        @if (popoverTitle) {
          <div class="d-flex align-items-center gap-2">
            <p
              style="cursor: default;"
              class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center action-button m-0"
            >
              <i
                #popover="ngbPopover"
                class="las la-info-circle fs-24"
                [ngbPopover]="popoverContent"
                [popoverClass]="'custom-popover'"
                [placement]="'auto'"
                triggers="manual"
                (click)="popover.open()"
                [autoClose]="'outside'"
                style="cursor: pointer;"
              ></i>
            </p>
            <ng-template #popoverContent>
              <div class="custom-popover">
                <div class="popover-header d-flex justify-content-between align-items-center"
                     style="user-select: text;">
                  <div class="fs-18"><strong>{{ popoverTitle }}</strong></div>
                  <button type="button" class="btn-close" aria-label="Close" (click)="popover.close()"></button>
                </div>
                <div class="popover-body" style="user-select: text;">
                  <p class="fs-18">{{ popoverDesc }}</p>
                </div>
              </div>
            </ng-template>
          </div>
        }
      </div>
      <div class="card-body-dashboard">
        <div class="d-flex justify-content-between align-items-center">
          <div class="w-50 row gap-y-2 text-dark border-end">
            <p class="p-0 m-0 mb-1 text-dark card-body-value">
              @if (isLoading) {
                <p-skeleton width="7rem" height="45px"></p-skeleton>
              } @else {
                @if (!valueLeft && valueLeft != 0) {
                  -
                } @else {
                  <span
                    *ngIf="valuePopover"
                    #valuePopoverRef="ngbPopover"
                    [ngbPopover]="valuePopoverContent"
                    [popoverClass]="'custom-popover'"
                    [placement]="['top', 'bottom', 'left', 'right']"
                    triggers="manual"
                    (click)="valuePopoverRef.open()"
                  >
                  {{ valueLeft }}
                </span>
                  <span *ngIf="!valuePopover">{{ valueLeft }}</span>
                  <span>{{ valueType | valueSuffix }}</span>
                }
              }
            </p>
            <p class="p-0 m-0 card-body-subtext mb-1 fs-15">{{ subtextLeft }}</p>
            <p *ngIf="percentLeft || percentLeft == 0" class="p-0 m-0 d-flex align-items-center gx-2">
              @if (isLoading) {
                <p-skeleton height="30px" width="50px"></p-skeleton>
              } @else {
                @if (!percentLeft && percentLeft != 0) {
                  -
                } @else {
                  <span class="p-1 rounded fw-bolder" [style]="getProfitStyle(profitType)">{{ percentLeft + '%' }}</span>
                }
              }
              <span class="card-body-subtext">{{ period || '' }}</span>
            </p>
          </div>
          <div class="w-50 row gap-y-2 text-dark">
            <p class="p-0 m-0 mb-1 text-dark card-body-value">
              @if (isLoading) {
                <p-skeleton width="7rem" height="45px"></p-skeleton>
              } @else {
                @if (!valueLeft && valueLeft != 0) {
                  -
                } @else {
                  <span
                    *ngIf="valuePopover"
                    #valuePopoverRef="ngbPopover"
                    [ngbPopover]="valuePopoverContent"
                    [popoverClass]="'custom-popover'"
                    [placement]="['top', 'bottom', 'left', 'right']"
                    triggers="manual"
                    (click)="valuePopoverRef.open()"
                  >
                  {{ valueRight }}
                </span>
                  <span *ngIf="!valuePopover">{{ valueRight }}</span>
                  <span>{{ valueType | valueSuffix }}</span>
                }
              }
            </p>
            <p class="p-0 m-0 card-body-subtext mb-1 fs-15">{{ subtextRight }}</p>
            <p *ngIf="percentRight || percentRight == 0" class="p-0 m-0 d-flex align-items-center gx-2">
              @if (isLoading) {
                <p-skeleton height="30px" width="50px"></p-skeleton>
              } @else {
                @if (!percentRight && percentRight != 0) {
                  -
                } @else {
                  <span class="p-1 rounded fw-bolder" [style]="getProfitStyle(profitType)">{{ percentRight + '%' }}</span>
                }
              }
              <span class="card-body-subtext">{{ period || '' }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <ng-template #valuePopoverContent>
      <div class="popover-header d-flex justify-content-between align-items-center">
        <h3><strong>{{ popoverTitle }}</strong></h3>
        <button type="button" class="btn-close" aria-label="Close" (click)="valuePopoverRef.close()"></button>
      </div>
      <div class="popover-body">
        <p class="fs-18">{{ valuePopover }}</p>
      </div>
    </ng-template>
  }
  @default {
    <div class="card" [class]="cardClass">
      <div class="card-header gap-2 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-2">
          <div class="d-inline-flex align-items-center justify-content-center rounded-circle"
               [class]="'circle-icon-' + iconColor">
            <i [class]="icon"></i>
          </div>
          <p class="p-0 m-0 text-dark fs-20 text-center">{{ title }}</p>
        </div>
        @if (popoverTitle) {
          <div class="d-flex align-items-center gap-2">
            <p
              style="cursor: default;"
              class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center action-button m-0"
            >
              <i
                #popover="ngbPopover"
                class="las la-info-circle fs-24"
                [ngbPopover]="popoverContent"
                [popoverClass]="'custom-popover'"
                [placement]="'auto'"
                triggers="manual"
                (click)="popover.open()"
                [autoClose]="'outside'"
                style="cursor: pointer;"
              ></i>
            </p>
            <ng-template #popoverContent>
              <div class="custom-popover">
                <div class="popover-header d-flex justify-content-between align-items-center"
                     style="user-select: text;">
                  <div class="fs-18"><strong>{{ popoverTitle }}</strong></div>
                  <button type="button" class="btn-close" aria-label="Close" (click)="popover.close()"></button>
                </div>
                <div class="popover-body" style="user-select: text;">
                  <p class="fs-18">{{ popoverDesc }}</p>
                </div>
              </div>
            </ng-template>
          </div>
        }
      </div>
      <div class="card-body-dashboard">
        <div class="row gap-y-2 text-dark">
          <p class="p-0 m-0 mb-1 text-dark card-body-value">
            @if (isLoading) {
              <p-skeleton width="7rem" height="45px"></p-skeleton>
            } @else {
              @if (!value && value != 0) {
                -
              } @else {
                <span
                  *ngIf="valuePopover"
                  #valuePopoverRef="ngbPopover"
                  [ngbPopover]="valuePopoverContent"
                  [popoverClass]="'custom-popover'"
                  [placement]="['top', 'bottom', 'left', 'right']"
                  triggers="manual"
                  (click)="valuePopoverRef.open()"
                >
                  {{ value }}
                </span>
                <span *ngIf="!valuePopover">{{ value }}</span>
                <span>{{ valueType | valueSuffix }}</span>
              }
            }
          </p>
          <p class="p-0 m-0 card-body-subtext mb-1 fs-15">{{ subtext }}</p>
          <p *ngIf=profit class="p-0 m-0 d-flex align-items-center gx-2">
            @if (isLoading) {
              <p-skeleton height="30px" width="50px"></p-skeleton>
            } @else {
              @if (!value && value != 0) {
                -
              } @else {
                <span class="p-1 rounded fw-bolder" [style]="getProfitStyle(profitType)">{{ profit }}</span>
              }
            }
            <span class="card-body-subtext">{{ period || '' }}</span>
          </p>
        </div>
      </div>
    </div>
    <ng-template #valuePopoverContent>
      <div class="popover-header d-flex justify-content-between align-items-center">
        <h3><strong>{{ popoverTitle }}</strong></h3>
        <button type="button" class="btn-close" aria-label="Close" (click)="valuePopoverRef.close()"></button>
      </div>
      <div class="popover-body">
        <p class="fs-18">{{ valuePopover }}</p>
      </div>
    </ng-template>
  }
}
